var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.info ? _c("div", [_c("information", {
    attrs: {
      policyInfo: _vm.info.policyInfo
    }
  }), _c("claims-info", {
    attrs: {
      claimsInfo: _vm.info.claimsInfo,
      policyNo: _vm.info.policyInfo.policyNo,
      type: "claim"
    }
  }), _c("compensation-info", {
    attrs: {
      payoutInfo: _vm.info.payoutInfo
    }
  }), _vm.info.payoutInfo.status == 1 && _vm.info.mailingInfo.csCompany ? _c("mail-info", {
    attrs: {
      mailingInfo: _vm.info.mailingInfo
    }
  }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };